import { HandCoins, Info, MessageCircle, ShieldCheck, Users } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { Link } from "react-router-dom";

import { Card } from "@/components/ui/Card";
import { PageHeading } from "@/components/ui/PageHeading";

interface Item {
  to: string;
  icon: LucideIcon;
  title: string;
  subtitle: string;
}

const items: Item[] = [
  {
    to: "/about",
    icon: Info,
    title: "About",
    subtitle: "Our masjid, our brand mark, and how to get involved.",
  },
  {
    to: "/community",
    icon: MessageCircle,
    title: "Community",
    subtitle: "Join the WhatsApp group for masjid updates.",
  },
  {
    to: "/committee",
    icon: Users,
    title: "Committee",
    subtitle: "Roles and members — pending Mashwara.",
  },
  {
    to: "/contribute",
    icon: HandCoins,
    title: "Contribute",
    subtitle: "Sadaqah and donation details.",
  },
  {
    to: "/admin",
    icon: ShieldCheck,
    title: "Admin",
    subtitle: "Sign in to manage the masjid app.",
  },
];

export function MorePage() {
  return (
    <div>
      <PageHeading eyebrow="More" title="Browse" subtitle="Other parts of the masjid app." />
      <div className="space-y-3 pb-8">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <Link
              key={it.to}
              to={it.to}
              className="block rounded-card transition-transform focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-masjidGreen active:scale-[0.99]"
            >
              <Card className="hover:border-masjidGreen/30">
                <div className="flex items-center gap-4">
                  <div
                    aria-hidden
                    className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-masjidGreen/10 text-masjidGreen"
                  >
                    <Icon size={20} strokeWidth={1.5} />
                  </div>
                  <div className="flex-1">
                    <div className="font-serif text-base text-ink">{it.title}</div>
                    <div className="text-sm text-muted">{it.subtitle}</div>
                  </div>
                  <div aria-hidden className="text-muted">›</div>
                </div>
              </Card>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
